(function () {
    'use strict';

    class CTRMarquee extends HTMLElement {
        constructor() {
            super();
            this.swiperInitialized = false;
            this.swiper = null;
            this.autoplayCheckInterval = null;
        }

        connectedCallback() {
            // Use multiple strategies to ensure initialization
            if (document.readyState === 'complete') {
                // DOM is fully loaded
                requestAnimationFrame(() => {
                    this.init();
                });
            } else if (document.readyState === 'interactive') {
                // DOM is ready but resources may still be loading
                requestAnimationFrame(() => {
                    this.init();
                });
            } else {
                // Wait for DOMContentLoaded
                document.addEventListener('DOMContentLoaded', () => {
                    requestAnimationFrame(() => {
                        this.init();
                    });
                }, { once: true });
            }

            // Also try after window load as fallback
            window.addEventListener('load', () => {
                if (!this.swiperInitialized) {
                    setTimeout(() => {
                        this.init();
                    }, 100);
                }
            }, { once: true });
        }

        init() {
            this.carouselSelector = this.querySelector('.js-marquee-swiper');

            this.initCarousel();

        }

        initCarousel() {
            if (!this.carouselSelector) {
                console.error('CTR Marquee: Carousel selector not found');
                return;
            }

            if (typeof window.Swiper === 'undefined' || !window.Swiper) {
                console.error('CTR Marquee: Swiper not available');
                return;
            }

            try {
                const transitionSpeed = 3000; // Smooth transition speed
                const autoplayDelay = 50; // Very short delay for continuous effect

                this.swiper = new window.Swiper(this.carouselSelector, {
                    slidesPerView: 'auto',
                    spaceBetween: this.gapMobile,
                    loop: true,
                    loopedSlides: 50,
                    speed: transitionSpeed,
                    allowTouchMove: true,
                    autoplay: {
                        delay: autoplayDelay,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        stopOnLastSlide: false
                    },
                    breakpoints: {
                        750: {
                            spaceBetween: this.gapDesktop,
                        },
                    },
                });

                const ensureAutoplay = () => {
                    if (this.swiper && this.swiper.autoplay) {
                        if (!this.swiper.autoplay.running) {
                            this.swiper.autoplay.start();
                        }
                    }
                };

                ensureAutoplay();

                this.swiper.on('touchEnd', ensureAutoplay);
                this.swiper.on('slideChange', ensureAutoplay);

                this.autoplayCheckInterval = setInterval(ensureAutoplay, 1000);

                this.swiperInitialized = true;
            } catch (error) {
                console.error('CTR Marquee: Error initializing Swiper', error);
            }
        }

        get gapDesktop() {
            return this.getAttribute('gap-desktop') ? parseInt(this.getAttribute('gap-desktop')) : 50;
        }

        get gapMobile() {
            return this.getAttribute('gap-mobile') ? parseInt(this.getAttribute('gap-mobile')) : 50;
        }

        get speed() {
            return this.getAttribute('speed') ? parseInt(this.getAttribute('speed')) : 5000;
        }

    }

    // Only define the custom element if it hasn't been defined yet
    if (typeof window.customElements !== 'undefined' && !window.customElements.get('ctr-marquee')) {
        window.customElements.define('ctr-marquee', CTRMarquee);
    } else if (typeof window.customElements === 'undefined') {
        console.error('CTR Marquee: Custom Elements not supported');
    }
})();